export const removeProtocolFromUrl = (url: string): string => {
  return url.replace(/^[a-zA-Z]+:\/\//, '');
};
